import { IconTitle1 } from '@xing-com/icons';

import * as Styled from '../styles';
import type { ToolProps } from '../types';

export const HeadingH1Tool: React.FC<ToolProps> = ({ editor, disabled }) => {
  return (
    <Styled.ToolBarButton
      onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
      disabled={
        disabled ||
        !editor.can().chain().focus().toggleHeading({ level: 1 }).run()
      }
      className={editor.isActive('heading', { level: 1 }) ? 'is-active' : ''}
    >
      <IconTitle1 width={24} height={24} />
    </Styled.ToolBarButton>
  );
};
